module.exports = __webpack_public_path__ + "media/start_page1.a355ff13.mp3";